<template>
  <SimplePageNorm title="退货管理">
    <StatusTabs :status-list="statusList" v-model="status" @change="statusChange"></StatusTabs>
    <OrderTable style="width:100%;height:calc(100% - 38px);" v-loading="loading" :data-list="dataList" @dataUpdate="loadData" show-type="normal"></OrderTable>
  </SimplePageNorm>
</template>

<script>
import SimplePageNorm from '@/components/base/SimplePageNorm'
import OrderTable from './detail/orderTable'
import StatusTabs from './detail/statusTabs'

import {
  orderRequest
} from '@/api'

export default {
  components: {
    SimplePageNorm,
    OrderTable,
    StatusTabs
  },
  created() {
    this.loadData()
  },
  data () {
    return {
      loading: false,
      status: 'wait_check',
      statusList: [{
        key: 'wait_check',
        label: '待审核',
        parm: {
          statusList: 'wait'
        }
      },
      {
        key: 'wait_ship',
        label: '待退货',
        parm: {
          statusList: 'pass',
          haveWaitShip: 1
        }
      },
      {
        key: 'wait_pay',
        label: '待退款',
        parm: {
          billStatus: 0
        }
      },
      {
        key: 'receipt',
        label: '已退款',
        parm: {
          billStatus: 1
        }
      },
      {
        key: 'check_down',
        label: '审核未通过',
        parm: {
          statusList: 'down'
        }
      }],
      dataList: []
    }
  },
  methods: {
    async loadData () {
      this.loading = true
      let parm = {
        typeList: 'back,back_order'
      }
      let status = this.statusList.find(v => v.key == this.status)
      parm = Object.assign(parm, (status ? status.parm : {}))
      this.dataList = await orderRequest.get(parm)
      let statusMap = {
        edit: '调整中',
        wait: '待审核',
        pass: '审核通过',
        down: '审核不通过'
      }
      this.dataList.forEach(v => {
        v.statusText = statusMap[v.status]
        v.makeType = v.type.includes('back') ? '退货' : (v.makeMainbodyId === v.buyMainbodyId ? '自主下单' : '代客下单')
      })
      this.loading = false
    },
    statusChange (value) {
      this.status = value
      this.loadData()
    }
  }
}
</script>

<style scoped lang="less"></style>